<template>
  <div class="common__pageContainer__3-VhW">
    <div class="common__pageBody__1Dn3a" style="">
      <div class="help__help__cLCx3">
        <div class="help__help_box__2kBjB help__clearfix__eGfiN">
          <div class="help__help_box_left__1rCP8">
            <ul class="help__parentUl__2pNA3">
              <div>
                <li data-analytics="menu" data-id="1" @click="changType(1)">
                  <div class="help__block__AtyXW" style="display: none"></div>
                  <div class="help__titleImg__2hQCq"><img src="/static/image/1587555761884253.png" /></div>
                  <span class="help__title__2KI0N">常见问题</span>
                </li>
              </div>
              <div>
                <li data-analytics="menu" data-id="1" @click="changType(2)">
                  <div class="help__block__AtyXW" style="display: none"></div>
                  <div class="help__titleImg__2hQCq"><img src="/static/image/1587556756778694.png" /></div>
                  <span class="help__title__2KI0N">博彩责任</span>
                </li>
              </div>
              <div>
                <li data-analytics="menu" data-id="1" @click="changType(3)">
                  <div class="help__block__AtyXW" style="display: none"></div>
                  <div class="help__titleImg__2hQCq"><img src="/static/image/1587555785235453.png" /></div>
                  <span class="help__title__2KI0N">隐私政策</span>
                </li>
              </div>
              <div>
                <li data-analytics="menu" data-id="1" @click="changType(4)">
                  <div class="help__block__AtyXW" style="display: none"></div>
                  <div class="help__titleImg__2hQCq"><img src="/static/image/1587555761884253.png" /></div>
                  <span class="help__title__2KI0N">免责说明</span>
                </li>
              </div>
              <div>
                <li data-analytics="menu" data-id="1" @click="changType(5)">
                  <div class="help__block__AtyXW" style="display: none"></div>
                  <div class="help__titleImg__2hQCq"><img src="/static/image/1587557843086979.png" /></div>
                  <span class="help__title__2KI0N">联络我们</span>
                </li>
              </div>
            </ul>
          </div>
          <div class="help__help_box_right__3vJ4w" style="position: relative" v-if="type == 1">
            <div>
              <!-- <div>
                <span style="color: #3366ff; font-size: 12pt"
                  ><strong><span class="_3-GEsycHey6eyCrPPOMOz4"> 常见问题</span></strong></span
                >
              </div> -->
              <div v-html="dataBox1.content"></div>
            </div>
          </div>

          <div class="help__help_box_right__3vJ4w" style="position: relative" v-if="type == 2">
            <div>
              <!-- <div>
                <span style="color: #3366ff; font-size: 12pt"
                  ><strong><span class="_3-GEsycHey6eyCrPPOMOz4"> 博彩责任</span></strong></span
                >
              </div> -->
              <div v-html="dataBox8.content"></div>
            </div>
          </div>

          <div class="help__help_box_right__3vJ4w" style="position: relative" v-if="type == 3">
            <div>
              <!-- <div>
                <span style="color: #3366ff; font-size: 12pt"
                  ><strong><span class="_3-GEsycHey6eyCrPPOMOz4"> 隐私政策</span></strong></span
                >
              </div> -->
              <div v-html="dataBox2.content"></div>
            </div>
          </div>

          <div class="help__help_box_right__3vJ4w" style="position: relative" v-if="type == 4">
            <div>
              <!-- <div>
                <span style="color: #3366ff; font-size: 12pt"
                  ><strong><span class="_3-GEsycHey6eyCrPPOMOz4"> 免责说明</span></strong></span
                >
              </div> -->
              <div v-html="dataBox3.content"></div>
            </div>
          </div>

          <div class="help__help_box_right__3vJ4w" style="position: relative" v-if="type == 5">
            <div>
              <!-- <div>
                <span style="color: #3366ff; font-size: 12pt"
                  ><strong><span class="_3-GEsycHey6eyCrPPOMOz4"> 联系我们</span></strong></span
                >
              </div> -->
              <div v-html="dataBox4.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'abouts',
  data() {
    // 1常见问题  2隐私政策  3免责说明  4联系我们  5代理加盟  7关于我们 8博彩责任
    return { type: 1, dataBox1: {}, dataBox2: {}, dataBox3: {}, dataBox4: {}, dataBox5: {}, dataBox7: {}, dataBox8: {} };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type;
    }
    let arr = [1, 2, 3, 4, 5, 7, 8];
    arr.forEach(el => {
      that.getAllCont(el);
    });
  },
  methods: {
    getAllCont(type) {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/article', { type })
        .then(res => {
          let name = 'dataBox' + type;
          that[name] = res.data;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changType(val) {
      this.type = val;
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
   watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        let query = this.$route.query;
        if (query.type) {
      that.type = query.type;

        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/Help_793450d6.19c3ccfc.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/abouts.vue